import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { InventoryService, SupplierService } from 'src/api/generated/services';
import { AddPurchaseOrder$Params } from 'src/api/generated/fn/inventory/add-purchase-order';
import { PurchaseOrderDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/purchase-order-dto';
import { SupplierDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Suppliers/supplier-dto';
import { StockItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-item-dto';
import { AddOrEditSupplierComponent } from "src/app/pos-panel/components/supplier/add-or-edit-supplier/add-or-edit-supplier.component";
import { AddOrEditInventoryItemComponent } from '../../add-or-edit-inventory-item/add-or-edit-inventory-item.component';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { Subscription } from 'rxjs';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { InfoStatusEnum } from 'src/app/share-modul/enums/infoStatus.enum';
import { GetStockItems$Params } from 'src/api/generated/fn/inventory/get-stock-items';
import { GetAllSuppliers$Params } from 'src/api/generated/fn/supplier/get-all-suppliers';
import { GetInventory$Params } from 'src/api/generated/fn/inventory/get-inventory';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { GetInventories$Params } from 'src/api/generated/fn/inventory/get-inventories';
import { GetSupplier$Params } from 'src/api/generated/fn/supplier/get-supplier';

@Component({
  selector: 'app-new-purchase-order',
  templateUrl: './new-purchase-order.component.html',
  styleUrls: ['./new-purchase-order.component.scss']
})
export class NewPurchaseOrderComponent implements OnInit, OnDestroy {

  venueId: string;
  inventoryId: string;
  purchaseOrder: PurchaseOrderDto = {} as PurchaseOrderDto;
  suppliers: Array<SupplierDto> = new Array<SupplierDto>();
  stockItemsList: Array<StockItemDto> = new Array<StockItemDto>();
  form: FormGroup;
  venueIdUpdateSubscription: Subscription;
  InfoStatusEnum = InfoStatusEnum;
  todaysDate: Date;
  inventoryDto: InventoryDto | undefined;
  inventories: Array<InventoryDto> = new Array<InventoryDto>();
  fromInventory: boolean = false;
  supplierDto: SupplierDto = {} as SupplierDto;
  supplierId :string;
  timezoneOffset: any;

  constructor(public dialogService: DialogService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    public inventoryService: InventoryService,
    private currentVenueHelper: CurrentVenueHelperService,
    private confirmationService: ConfirmationService,
    public translate: TranslateService,
    private messageService: MessageService,
    private supplierService: SupplierService) {

      this.route.params.subscribe(params => {
        this.fromInventory = params['supplier-id'] == null;
        this.createForm(); 
      })
  }

  ngOnInit(): void {
    this.todaysDate = new Date();
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.currentVenueHelper.getTimezone().subscribe(tzOffset => this.timezoneOffset = tzOffset)
      }
      if (params['inventory-id'] != null) {
        this.inventoryId = params['inventory-id'];
        this.fromInventory = true;
        
        const invetoryParams: GetInventory$Params = { inventoryId: this.inventoryId };
        this.inventoryService.getInventory(invetoryParams).subscribe(response => this.inventoryDto = response)

        const suppliersParams: GetAllSuppliers$Params = { isRemoved: false };
        this.supplierService.getAllSuppliers(suppliersParams).subscribe(response => this.suppliers = response.suppliers ? response.suppliers : []);
      }
      if (params['supplier-id'] != null) {
        this.supplierId = params['supplier-id'];
        this.fromInventory = false;
        const invetoryParams: GetInventories$Params = { venueId: this.venueId , isRemoved:false };
        this.inventoryService.getInventories(invetoryParams).subscribe(response => {
          this.inventories = response.inventories ? response.inventories : [];
          this.inventoryDto = this.inventories.find(inventory => inventory.isMain);
        })

        const suppliersParams: GetSupplier$Params = { supplierId: this.supplierId };
        this.supplierService.getSupplier(suppliersParams).subscribe(response => this.supplierDto = response);
      }
    });

    this.getStockItems();
  }

  addNewSupplier() {
    const ref = this.dialogService.open(AddOrEditSupplierComponent, {
      width: '372px',
      showHeader: false
    });
    ref.onClose.subscribe((item: any) => {
      if (item) {
        const suppliersParams: GetAllSuppliers$Params = { isRemoved: false };
        this.supplierService.getAllSuppliers(suppliersParams).subscribe(response => this.suppliers = response.suppliers ? response.suppliers : []);
      }
    });
  }

  addNewInventoryItem() {
    const ref = this.dialogService.open(AddOrEditInventoryItemComponent, {
      width: '372px',
      showHeader: false
    });
    ref.onClose.subscribe((response: any) => {
      if (response) {
        this.getStockItems();
        this.messageService.add({ severity: 'success', summary: 'Item was successfully added!', life: 3000 });
      } else if (response == false) {
        this.messageService.add({ severity: 'error', summary: 'Error occurred!', life: 3000 });
      }
    });
  }
  getStockItems(){
    const stockItemsParams: GetStockItems$Params = { isRemoved: false };
    this.inventoryService.getStockItems(stockItemsParams).subscribe(response => this.stockItemsList = response.stockItems ? response.stockItems : []);
  }

  private createForm(): void {
    if(!this.fromInventory){
      this.form = this.formBuilder.group({
        orders: this.formBuilder.array([
          this.createTableRow()
        ])
      });   
    } else {
      this.form = this.formBuilder.group({
        orders: this.formBuilder.array([
          this.createTableRow()
        ]),
        supplier: new FormControl('', {
          validators: [Validators.required]
        })
      });   
    }
  }

  private createTableRow(): FormGroup {
    return this.formBuilder.group({
      stockItem: new FormControl('', {
        validators: [Validators.required]
      }),
      quantityOrdered: new FormControl('', {
        validators: [Validators.required]
      })
    });
  }

  addNewRow(): void {
    this.orders.push(this.createTableRow());
  }

  get orders(): FormArray {
    return this.form.get('orders') as FormArray;
  }

  getOrderControls(index: number){
    return (this.orders.controls[index] as FormGroup)
  }

  onDeleteRow(rowIndex: number): void {
    this.orders.removeAt(rowIndex);
  }

  createOrder() {
    if(this.form.valid){
   this.confirmationService.confirm({
      header: this.translate.instant('PURCHASE_ORDER.CONFIRMATION_DIALOG_CREATE_ORDER_TITLE'),
      message: this.translate.instant('PURCHASE_ORDER.CONFIRMATION_DIALOG_CREATE_ORDER_QUESTION'),
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn constructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        const params: AddPurchaseOrder$Params = { inventoryId: this.inventoryDto && this.inventoryDto.id ? this.inventoryDto.id : this.inventoryId, body: { lineItems: this.orders.getRawValue(), supplier: this.fromInventory ? this.purchaseOrder.supplier : this.supplierDto } };
        this.inventoryService.addPurchaseOrder(params).subscribe({
          next: response => {
            this.messageService.add({ severity: 'success', summary: 'The order was successfully created!', life: 3000 });
            this.navigateToMain();
          },
          error: errorResponse => this.messageService.add({ severity: 'error', summary: 'Error occurred!', life: 3000 })
        });
      }
      
    });
  }

  }

  navigateToMain() {
    if (this.fromInventory) {
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 1 } });
    }
    else {
      this.router.navigate([this.venueId, "supplier"]);
    }
  }

  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }


}